// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"412":"60f900d5","444":"9077b474","663":"e18f8059"}[chunkId] + ".css";
};